import { createStore } from 'vuex'
import websocket from './modules/websocket'
import parentData from './modules/parentData'

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    websocket,
    parentData
  }
}) 